import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const Box = ({
  children,
  bgColor,
  color,
  className,
  square = false,
  onClick,
  ...props
}) => {
  return (
    <div
      {...props}
      style={{ '--bg': bgColor, '--color': color }}
      className={cn(styles.root, className, {
        [styles.interactive]: typeof onClick === 'function',
      })}
      data-type={square ? 'square' : 'default'}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Box;
